import React from "react";
import ListUser from "./ListUser";
import ListKorwil from "./ListKorwil";
import ListAreaManager from "./ListAreaManager";
import ListSupervisor from "./ListSupervisor";
import ListMarketing from "./ListMarketing";
import ListBPD from "./ListBPD";
import { Card, Nav, Container, Row, Col, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import SplitText from "views/SplitText";

function IndexUser() {
  const auth = useSelector((state) => state.authReducer);
  const [status, setStatus] = React.useState("");
  const [key, setKey] = React.useState("");
  React.useEffect(() => {
    if (auth && auth.role) {
      // Jika super admin, set ke 'user', jika bukan set ke 'korwil'
      const defaultTab = auth.role === "super admin" ? "user" : "korwil";
      setKey(defaultTab);
    }
  }, [auth]);
  // React.useEffect(() => {
  //   setStatus(auth.role);
  // }, [auth.role]);
  return (
    <>
      <Container fluid className="pt-4">
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "25px", overflow: "hidden" }}
            >
              {/* HEADER GAYA BPR JATIM */}
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex align-items-center">
                  <div
                    className="mr-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      background:
                        "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                      borderRadius: "12px",
                      color: "white",
                    }}
                  >
                    <i
                      className="fas fa-users-cog fa-lg"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%", // Paksa icon ambil ruang penuh
                        margin: 0,
                        padding: 0,
                        lineHeight: 1,
                        textAlign: "center",
                      }}
                    ></i>
                  </div>
                  <div>
                    <Card.Title
                      as="h3"
                      className="m-0"
                      style={{
                        color: "#1e293b",
                        textTransform: "uppercase",
                        fontWeight: "900",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Manajemen User
                    </Card.Title>
                    <p className="text-muted small m-0 fw-600">
                      Kelola akses dan data seluruh tim lapangan
                    </p>
                  </div>
                </div>
                <hr className="mt-4 mb-0" style={{ opacity: "0.05" }} />
              </Card.Header>

              <Card.Body className="p-0">
                <Tab.Container
                  id="user-management-tabs"
                  activeKey={key} // Ganti defaultActiveKey menjadi activeKey
                  onSelect={(k) => setKey(k)} // Update state saat tab diklik
                >
                  {/* NAVIGASI TAB GAYA PILL (RESPONSIVE) */}
                  <div className="px-4 pt-3 bg-light-soft">
                    <Nav
                      variant="pills"
                      className="nav-pills-custom flex-column flex-sm-row"
                      style={{ gap: "10px" }}
                    >
                      {auth.role === "super admin" && (
                        <Nav.Item>
                          <Nav.Link
                            eventKey="user"
                            className="tab-pill shadow-sm"
                          >
                            <i className="fas fa-user-shield mr-2"></i> User
                            Admin
                          </Nav.Link>
                        </Nav.Item>
                      )}
                      <Nav.Item>
                        <Nav.Link
                          eventKey="korwil"
                          className="tab-pill shadow-sm"
                        >
                          <i className="fas fa-map-marked-alt mr-2"></i> Korwil
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="areamaneger"
                          className="tab-pill shadow-sm"
                        >
                          <i className="fas fa-user-tie mr-2"></i> Area Manager
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="supervisor"
                          className="tab-pill shadow-sm"
                        >
                          <i className="fas fa-user-check mr-2"></i> Supervisor
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="marketing"
                          className="tab-pill shadow-sm"
                        >
                          <i className="fas fa-users mr-2"></i> Sales Marketing
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="korcab"
                          className="tab-pill shadow-sm"
                        >
                          <i className="fas fa-university mr-2"></i> BPD /
                          Cabang
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>

                  {/* KONTEN TAB DENGAN ANIMASI FADE */}
                  <Tab.Content className="p-4 animate-fade-in">
                    <Tab.Pane eventKey="user">
                      <div className="table-container">
                        <ListUser />
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="korwil">
                      <div className="table-container">
                        <ListKorwil />
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="areamaneger">
                      <div className="table-container">
                        <ListAreaManager />
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="supervisor">
                      <div className="table-container">
                        <ListSupervisor />
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="marketing">
                      <div className="table-container">
                        <ListMarketing />
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="korcab">
                      <div className="table-container">
                        <ListBPD />
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* CSS STYLING UNTUK INTERAKSI PREMIUM */}
        <style>{`
    .bg-light-soft { background-color: #f8fafc; border-bottom: 1px solid #f1f5f9; }
    
    .tab-pill {
      border: 1px solid #e2e8f0 !important;
      background-color: white !important;
      color: #64748b !important;
      font-weight: 700 !important;
      font-size: 13px !important;
      border-radius: 12px !important;
      padding: 12px 20px !important;
      transition: all 0.3s ease !important;
      text-align: center;
    }

    /* Hover State */
    .tab-pill:hover {
      background-color: #f1f5f9 !important;
      color: #2e3192 !important;
    }

    /* Active State (Merah BPR Jatim) */
    .nav-pills .nav-link.active {
      background: linear-gradient(135deg, #f90203 0%, #ff4d4d 100%) !important;
      color: white !important;
      border-color: transparent !important;
      box-shadow: 0 8px 15px rgba(249, 2, 3, 0.2) !important;
    }

    .animate-fade-in {
      animation: fadeIn 0.4s ease-in-out;
    }

    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(5px); }
      to { opacity: 1; transform: translateY(0); }
    }

    /* Responsive adjustment */
    @media (max-width: 576px) {
      .tab-pill { margin-bottom: 5px; width: 100%; }
      .nav-pills-custom { padding: 0 10px; }
      h3 { fontSize: 18px !important; }
    }
    
    .fw-600 { font-weight: 600; }
    .table-container { border-radius: 15px; overflow: hidden; }
  `}</style>
      </Container>
    </>
  );
}

export default IndexUser;
